<script lang="ts">
  import StorefrontContainer from "@shared/svelte/Components/Storefront/StorefrontContainer.svelte";
  import { default as CraftNavigation } from "@modern/components/retailer/Navigation/ProductLinesNavigation.svelte";
  import { HttpPromise, HttpPromiseWithEntireResponse } from "@shared/svelte/Modules/ApiService";
  import PageWrapper from "@retailer/svelte/Shared/PageWrapper.svelte";
  import * as _ from "lodash";

  import { getPricesForSearchResult } from "@retailer/services/pricing_data_service";
  import type { CatalogPagination, Storefront } from "@shared/types/Storefront";
  import { isRestrictedRole } from "@retailer/services/preview_forbidden_flash";

  export let storefront: Storefront;
  let catalogPage: number = 1;
  let catalogParams = {};

  if (!storefront) {
    window.location.href = "/404";
  }

  const pullPrices = async productLines => {
    if (isRestrictedRole(["supplier"])) {
      return;
    }

    return getPricesForSearchResult(productLines);
  };

  const pullCatalog = async params => {
    if (!params) {
      params = {};
    }
    if (params.search == "") {
      delete params.search;
    }
    catalogParams = params;
    let options = {
      method: "GET",
      url: "/api/retailer/product_lines",
      data: _.merge(params, {
        limit: storefront.catalog_items_per_page,
        distributor_ids: [storefront.distributor_id],
        offset: storefront.catalog_items_per_page * (catalogPage > 0 ? catalogPage - 1 : 0),
        catalog_sort: storefront.catalog_sort_by,
        storefront: true,
      }),
    };
    let res = await HttpPromiseWithEntireResponse(options);
    let catalogPagination: CatalogPagination = {
      perPage: storefront.catalog_items_per_page,
      page: catalogPage,
      totalEntries: parseInt(res.headers.get("X-Pagination-Entries")),
      goToPage: function (n) {
        catalogPage = n;
        pullCatalog(catalogParams);
      },
    };
    let data = await res.json();

    const inventoryPrices = await pullPrices(data);

    storefront = {
      ...storefront,
      catalog: data,
      catalogPagination: catalogPagination,
      inventoryPrices,
    };
    return res;
  };

  const camelToSnakeCase = str => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

  const pullAvailableFilters = params => {
    let currentParams = {};
    let paramKeys = _.keys(params);
    _.each(paramKeys, key => {
      currentParams[camelToSnakeCase(key)] = params[key] || null;
    });
    let options = {
      method: "GET",
      url: "/api/retailer/product_lines/available_filters",
      data: _.merge(currentParams, {
        distributor_ids: [storefront.distributor_id],
        catalog_sort: storefront.catalog_sort_by,
      }),
    };
    return HttpPromise(options);
  };

  if (storefront) {
    pullCatalog(catalogParams);
  }
  let callbacks = {
    pullCatalog: pullCatalog,
    pullAvailableFilters: pullAvailableFilters,
  };

  $: innerWidth = window.innerWidth;
</script>

<svelte:window bind:innerWidth />
<PageWrapper let:mobileMode>
  <div>
    <CraftNavigation />
  </div>

  {#if storefront}
    <StorefrontContainer {callbacks} bind:storefront />
  {/if}
</PageWrapper>
